import { rowsToText } from "../../domain/testing";
import { t } from "../../i18n";

/**
 * A results file as text `parseResults` can read: CSV as it is, the first
 * sheet of an Excel workbook row by row. Nothing is interpreted here — the
 * parser reports any line it cannot read, by number.
 */
export async function readResultsFile(file: File): Promise<string> {
  const name = file.name.toLowerCase();
  if (name.endsWith(".xlsx")) {
    const { default: readXlsxFile } = await import("read-excel-file/browser");
    const rows = await readXlsxFile(file);
    return rowsToText(rows as unknown as unknown[][]);
  }
  if (name.endsWith(".csv") || name.endsWith(".txt") || file.type.startsWith("text/")) return file.text();
  throw new Error(t("results are read from a .csv or .xlsx file"));
}
